import type { RouteObject } from 'react-router';
import { AdminRootView } from 'src/admin/views/AdminRootView';
import { EventEditorView } from 'src/admin/views/EventEditorView';
import { ErrorPage } from 'src/components/ErrorPage';
import { accountRoutes } from './account.routes';
import { billingRoutes } from './billing.routes';
import { ConnectionChartRedirect } from './ConnectionChartRedirect';
import { eventEditorRoutes } from './event-editor.routes';
import { messageTemplatesRoutes } from './message-templates.routes';

export const adminRoutes: Array<RouteObject> = [
  {
    path: 'admin',
    element: <AdminRootView />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: 'events',
        lazy: async () => {
          const comp = await import('../admin/views/TrackingMapsListView');
          return { Component: comp.TrackingMapsListView };
        },
      },
      {
        path: 'events/create',
        lazy: async () => {
          const comp = await import('../admin/views/TrackingMapsListView');
          return { Component: comp.TrackingMapsListView };
        },
      },
      {
        path: 'events/manage',
        lazy: async () => {
          const comp = await import('../admin/views/ManageEventsView');
          return { Component: comp.ManageEventsView };
        },
      },
      {
        path: 'events/timeline',
        lazy: async () => {
          const comp = await import('../admin/views/EventTimelineView');
          return { Component: comp.EventTimelineView };
        },
      },
      {
        path: 'events/new',
        lazy: async () => {
          const comp = await import('../admin/views/EventCreatorView');
          return { Component: comp.EventCreatorView };
        },
      },
      {
        path: 'events/:eventId/actions/duplicate',
        lazy: async () => {
          const comp = await import('../admin/views/EventDuplicateView');
          return { Component: comp.EventDuplicateView };
        },
      },
      {
        path: 'events/:eventId',
        element: <EventEditorView />,
        errorElement: <ErrorPage />,
        children: eventEditorRoutes,
      },
      {
        path: 'stagegroups/:stageGroupId/stages/new',
        lazy: async () => {
          const comp = await import('../admin/views/StageCreatorView');
          return { Component: comp.StageCreatorView };
        },
      },
      {
        path: 'users',
        lazy: async () => {
          const comp = await import('../admin/views/UserManagerView');
          return { Component: comp.UserManagerView };
        },
      },
      {
        path: 'user-feedback',
        lazy: async () => {
          const comp = await import('../admin/views/UserHelpRequestView');
          return { Component: comp.UserHelpRequestView };
        },
      },
      {
        path: 'starter-tags',
        lazy: async () => {
          const comp = await import('../admin/views/StarterTagsView');
          return { Component: comp.StarterTagsView };
        },
      },
      {
        path: 'user-credits',
        lazy: async () => {
          const comp = await import('../admin/views/UserCreditsView');
          return { Component: comp.UserCreditsView };
        },
      },
      {
        path: 'trackers/*',
        lazy: async () => {
          const comp = await import('../admin/views/TrackerManagerView');
          return { Component: comp.TrackerManagerView };
        },
      },
      {
        path: 'contestgroups/new',
        lazy: async () => {
          const comp = await import('../admin/views/ContestGroupCreatorView');
          return { Component: comp.ContestGroupCreatorView };
        },
      },
      {
        path: 'stagegroups/new',
        lazy: async () => {
          const comp = await import('../admin/views/StageGroupCreatorView');
          return { Component: comp.StageGroupCreatorView };
        },
      },
      {
        path: 'safemaps/new',
        lazy: async () => {
          const comp = await import('../admin/views/SafemapCreatorView');
          return { Component: comp.SafemapCreatorView };
        },
      },
      {
        path: 'connection-chart/:appId',
        lazy: async () => {
          const comp = await import('../admin/views/ConnectionChartView');
          return { Component: comp.ConnectionChartView };
        },
      },
      {
        path: 'track/:appId',
        element: <ConnectionChartRedirect />,
      },
      {
        path: 'sim-cards',
        lazy: async () => {
          const comp = await import('../admin/views/SimCardsView');
          return { Component: comp.SimCardsView };
        },
      },
      {
        path: 'log-level',
        lazy: async () => {
          const comp = await import('../admin/views/LogLevelView');
          return { Component: comp.LogLevelView };
        },
      },
      {
        path: 'tracker-labels',
        lazy: async () => {
          const comp = await import('../admin/views/TrackerLabelsView');
          return { Component: comp.TrackerLabelsView };
        },
      },
      {
        path: 'tracker-labels/new',
        lazy: async () => {
          const comp = await import('../admin/views/TrackerLabelWizardView');
          return { Component: comp.TrackerLabelWizardView };
        },
      },
      {
        path: 'tracker-labels/:printingId',
        lazy: async () => {
          const comp = await import('../admin/views/TrackerLabelWizardView');
          return { Component: comp.TrackerLabelWizardView };
        },
      },
      {
        path: 'feature-usage/:featureId?',
        lazy: async () => {
          const comp = await import('../admin/views/FeatureUsageView');
          return { Component: comp.FeatureUsageView };
        },
      },
      ...messageTemplatesRoutes,
      ...accountRoutes,
      ...billingRoutes,
    ],
  },
];
